// extracted by mini-css-extract-plugin
module.exports = {"paperContainer":"ChannelProfileDH_paperContainer__2pRVr","title":"ChannelProfileDH_title__31Yw7","mainContainer":"ChannelProfileDH_mainContainer__3DC1G"};